import React from "react";

const Map = (props) => {
  const { address } = props;

  if (address) {
    const mapUrl = `https://www.google.com/maps/embed/v1/place?key=
    AIzaSyDoXYEGgcwlbcddbsD_7uABhpzeQkeHV70&q=${address}`;

    return (
      <div>
        <iframe
          width="100%"
          height="250"
          frameBorder="0"
          style={{ border: "0" }}
          src={mapUrl}></iframe>
      </div>
    );
  }
  return null;
};

export default Map;
